/* eslint-disable no-inner-declarations */
<template>

  <div id="app" v-preventright class="app">
    <router-view />
    <el-dialog
      title="应用更新......"
      :visible="showUpdater"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
      width="620px"
      top="26vh"
      center
    >
      <template v-if="downloadProcess">
        <p>
          {{
            "当前:" +
              downloadProcess.transferred +
              "   /   共" +
              downloadProcess.total
          }}
        </p>
        <el-progress
          :text-inside="true"
          :stroke-width="18"
          :percentage="downloadProcess.percent"
        ></el-progress>
        <p>正在下载({{ downloadProcess.speed }})......</p>
      </template>
    </el-dialog>
  </div>
</template>
<script>
// eslint-disable-next-line no-unused-vars
/*global hqWs protocol BaseApi hqProtocol protocolTrans  http util*/
import { mapGetters } from 'vuex'
export default {
  name: 'App',
  data() {
    return {
      showUpdater: false,
      downloadProcess: null,
      dialogVisible: false,
      getKey: null,
      getTel: null
    }
  },
  computed: {
    ...mapGetters([
      'sessionInfoGetter'
    ]),
    isLogin() {
      if (
        this.sessionInfoGetter &&
        this.sessionInfoGetter['sessionStr'] &&
        this.sessionInfoGetter['userId']
      ) {
        return true
      }
      return false
    }
  },
  created() {
    // 测试数据
    // http://localhost:8084/#/login?redirect=%2FmallIndex%2FequityMall%3FuserId%253D100199%2526firmId%253D219207%2526lnvitationCode%253Dundefined%2526sessionStr%253D9F0F0D256D0288D2A5FB3A7C59E3CC61%2526tel%253D13114958845
    if (window.location.href.indexOf('sessionStr') != -1) { // 判断是否是跳转过来的
      const oldParInfo = decodeURIComponent('userId' + window.location.href.split('userId')[1])
      // const oldParInfo = Object.keys(option)[0]
      const twoInfo = this.urlToObject(oldParInfo)
      const sessionInfo = {}
      sessionInfo.isLogin = true
      sessionInfo.userId = twoInfo.userId
      sessionInfo.sessionStr = twoInfo.sessionStr
      sessionInfo.firmCode = ''
      sessionInfo.tel = twoInfo.tel
      sessionInfo.firmId = twoInfo.firmId
      localStorage.setItem('myPhone', sessionInfo.tel)
      this.$store.commit('setSessionInfo', sessionInfo)
      localStorage.setItem('equipmentFlag_PC', Number(twoInfo.equipmentFlag))
      const toUrl = window.location.href.split('#')[1].split('?')[0]
      this.$router.push(toUrl)
    } else {
      this.equipmentSearch()
    }
  },
  mounted() {
    // if (window.location.href.split('?')[1]) {
    //   this.getKey = window.location.href.split('?')[1].split('&')[0].split('=')[1]
    //   this.getTel = window.location.href.split('?')[1].split('&')[1].split('=')[1]
    //   this.getSession()
    // }
    this.getServerTime() // 获取服务器时间
    if (window.g.APP_TITLE_ALL) {
      document.title = window.g.APP_TITLE_ALL
    }
    // 仅在Electron模式下
    if (process.env.IS_ELECTRON) {
      this.electronCheckUpdate()
    }
  },
  methods: {
    // 获取服务器时间
    getServerTime() {
      const clientTime = Date.now() // 记录请求发送时的客户端时间
      http.postFrontMall(protocol.param_getServerTime).then((res) => {
        const { code, value } = res.data
        if (code === 0 || code === '0') {
          // value.serverTime 是后端返回的服务器时间戳
          if (value && value.serverTime) {
            const responseTime = Date.now()
            // 考虑网络延迟，取请求和响应时间的中间值
            const networkDelay = (responseTime - clientTime) / 2
            const serverTimeOffset = value.serverTime + networkDelay - clientTime
            // 存入 Vuex
            this.$store.commit('setServerTimeOffset', serverTimeOffset)
          }
        }
      }).catch(() => {
        // 如果获取失败，偏移量保持为 0，使用客户端时间
        console.log('获取服务器时间失败，使用客户端时间')
      })
    },
    urlToObject(urlString) {
      var urlObject = {}
      var urlArray = urlString.split('&')
      for (let i = 0, len = urlArray.length; i < len; i++) {
        const urlItem = urlArray[i]
        const item = urlItem.split('=')
        urlObject[item[0]] = item[1]
      }
      return urlObject
    },
    getSession() {
      // 得到秘钥
      const url =
        `base-desk-query/userSession/getSession?key=${this.getQueryVariable('key') ? this.getQueryVariable('key') : this.getKey}`
      // eslint-disable-next-line no-unused-vars
      protocol.param_getSession.url = url
      http.getRes(protocol.param_getSession).then((response) => {
        var { code, message, value } = response.data
        if (Number(code) === 0) {
          // console.log(value)
          this.type = value.split('-')[0]
          this.session = value.split('-')[1]
          this.userId = value.split('-')[2]
          localStorage.setItem('isLogin', true)
          localStorage.setItem('userId', this.userId)
          localStorage.setItem('sessionStr', this.session)
          const sessionInfo = {}
          sessionInfo.isLogin = true
          sessionInfo.userId = this.userId
          sessionInfo.sessionStr = this.session
          sessionInfo.tel = this.getQueryVariable('tel') ? this.getQueryVariable('tel') : this.getTel
          sessionInfo.firmId = ''
          this.$store.commit('setSessionInfo', sessionInfo)
          localStorage.setItem('tels', sessionInfo.tel)
          this.getUserInfo(this.userId, this.session)
        } else {
          this.$toast(message)
        }
      })
    },
    getUserInfo(userId, session) {
      http.postFront(protocol.param_findByUserId).then((response) => {
        var { code, value, message } = response.data
        if (Number(code) === 0) {
          // console.log(value)
          const values = {
            banTime: null,
            cellPhone: this.getQueryVariable('tel') ? this.getQueryVariable('tel') : this.getTel,
            firmId: value.firmId,
            lnvitationCode: value.lnvitationCode,
            nickName: null,
            sessionStr: session,
            type: value.type,
            userCode: value.userCode,
            userId: userId,
            userName: value.userName
          }
          this.loginWithValues(values)
        } else {
          this.$toast(message)
        }
      })
    },
    // 获取url参数
    getQueryVariable(variable) {
      const urlJson = this.$route.query
      if (variable && urlJson && urlJson[variable]) {
        return urlJson[variable]
      }
      return false
    },
    equipmentSearch() {
      var u = navigator.userAgent
      if (u.indexOf('Electron') != -1) {
        // pc 客户端
        localStorage.setItem('equipmentFlag_PC', 1)
      } else {
        // pc web端
        localStorage.setItem('equipmentFlag_PC', 4)
      }
    },
    // 判断当前用户是否修改过资金密码
    getMoneyPwdFlgByFirmId() {
      const that = this
      http.postFront(protocol.param_getMoneyPwdFlgByFirmId).then((response) => {
        const { code, value } = response.data
        if (code === 0 || code === '0') {
          that.$store.commit('setChangeMarginPsd', value)
          if (value === true) {
            that.$alert('登录后请先修改资金密码，否则无法进行交易', '提示', {
              confirmButtonText: '确定',
              callback: (action) => {}
            })
          }
        }
      })
    },
    // input禁止滚轮事件(为兼容Firefox)
    banRoller() {
      function MouseWheel(event) {
        event = event || window.event
        event.preventDefault()
      }
      const aInp = document.getElementsByTagName('input')
      for (let i = 0; i < aInp.length; i++) {
        aInp[i].addEventListener('DOMMouseScroll', MouseWheel, false)
      }
    },
    electronCheckUpdate() {
      const { ipcRenderer } = require('electron')
      // 发现新版本
      ipcRenderer.once('autoUpdater-latestVersion', (event, info) => {
        // console.log(event)
        setTimeout(() => {
          // this.$notify({
          //   title: '版本检查',
          //   message: '当前已是最新版本',
          //   type: 'success',
          //   position: 'bottom-right'
          // })
          console.log('当前已是最新版本')
        }, 500)
      })
      ipcRenderer.once('autoUpdater-canUpdate', (event, info) => {
        console.log(event)
        setTimeout(() => {
          // this.$confirm(`发现有新版本【v${info.version}】，是否更新?`, '提示', {
          //   confirmButtonText: '确定',
          //   cancelButtonText: '取消',
          //   confirmButtonClass: 'color-white',
          //   type: 'warning',
          //   closeOnClickModal: false
          // }).then(() => {
          //   ipcRenderer.send('autoUpdater-toDownload')
          // })
          this.$alert(
            `发现有新版本【v${info.version}】，请更新至最新版本`,
            '提示',
            {
              confirmButtonText: '立即更新',
              showClose: false,
              confirmButtonClass: 'color-white',
              callback: action => {
                ipcRenderer.send('autoUpdater-toDownload')
              }
            }
          )
        }, 500)
      })
      // 下载进度
      ipcRenderer.on('autoUpdater-progress', (event, process) => {
        console.log(event)
        if (process.transferred >= 1024 * 1024) {
          process.transferred =
            (process.transferred / 1024 / 1024).toFixed(2) + 'M'
        } else {
          process.transferred = (process.transferred / 1024).toFixed(2) + 'K'
        }
        if (process.total >= 1024 * 1024) {
          process.total = (process.total / 1024 / 1024).toFixed(2) + 'M'
        } else {
          process.total = (process.total / 1024).toFixed(2) + 'K'
        }
        if (process.bytesPerSecond >= 1024 * 1024) {
          process.speed =
            (process.bytesPerSecond / 1024 / 1024).toFixed(2) + 'M/s'
        } else if (process.bytesPerSecond >= 1024) {
          process.speed = (process.bytesPerSecond / 1024).toFixed(2) + 'K/s'
        } else {
          process.speed = process.bytesPerSecond + 'B/s'
        }
        process.percent = Number(process.percent.toFixed(2))
        this.downloadProcess = process
        this.showUpdater = true
      })
      // 下载更新失败
      ipcRenderer.once('autoUpdater-error', event => {
        setTimeout(() => {
          this.$notify({
            title: '版本更新',
            message: '连接服务器失败，正在尝试重连……',
            type: 'error',
            position: 'bottom-right'
          })
        }, 500)
        setTimeout(() => {
          this.showUpdater = false
        }, 1500)
        const checkNetwork = setInterval(() => {
          console.log(navigator.onLine)
          if (navigator.onLine === true) {
            ipcRenderer.send('check-update')
            clearInterval(checkNetwork)
          }
        }, 5000)
      })
      // 下载完成
      ipcRenderer.once('autoUpdater-downloaded', () => {
        // this.$confirm(`更新完成，是否关闭应用程序安装新版本?`, '提示', {
        //   confirmButtonText: '确定',
        //   cancelButtonText: '取消',
        //   confirmButtonClass: 'color-white',
        //   type: 'warning',
        //   closeOnClickModal: false
        // }).then(() => {
        //   ipcRenderer.send('exit-app')
        // })
        this.$alert(`下载完成，即将关闭应用程序安装新版本。`, '提示', {
          confirmButtonText: '立即安装',
          showClose: false,
          confirmButtonClass: 'color-white',
          callback: action => {
            ipcRenderer.send('exit-app')
          }
        })
      })
      ipcRenderer.send('check-update')
    }
  }
}
</script>
<style lang="scss">
// @import './assets/images/main.min.css';
// @import './assets/images/walletcenter.min.css';
#app {
  // min-width: 1400px;
  min-width: 1200px;
  height: 100vh;
  overflow: auto;
  position: relative;
}
* {
  margin: 0px;
  padding: 0px;
  // color: #b0b8db;
  // font-family: 'libaba PuHuiTi-Regular, Alibaba PuHuiTi';
}

body {
  font-size: 12px;
  font-family: 'libaba PuHuiTi-Regular, Alibaba PuHuiTi';
  // background-color: #141625;
}
#login .msgYszmInput .el-input__inner{
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  border-right:0;
}

/*定义滚动条宽高及背景，宽高分别对应横竖滚动条的尺寸*/

::-webkit-scrollbar {
  width: 4px;
  height: 4px;
  background-color: transparent;
}
/*定义滚动条轨道 内阴影+圆角*/
::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  border-radius: 10px;
  background-color: transparent!important;
}
/*定义滑块 内阴影+圆角*/
::-webkit-scrollbar-thumb {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  // background-color: lightgray!important;
}
/*滑块效果*/
// ::-webkit-scrollbar-thumb:hover
// {
// border-radius: 5px;
// -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
// background: rgba(0,0,0,1);
// }
/*IE滚动条颜色*/
html {
  scrollbar-face-color: #0c0c0c; /*滚动条颜色*/
  scrollbar-highlight-color: transparent;
  scrollbar-3dlight-color: transparent;
  scrollbar-darkshadow-color: transparent;
  scrollbar-shadow-color: transparent; /*滑块边色*/
  scrollbar-arrow-color: rgba(0, 0, 0, 0.4); /*箭头颜色*/
  scrollbar-track-color: transparent; /*背景颜色*/
}
/deep/ .el-input-group__append {
  background: transparent;
  border: 1px solid rgba(220, 223, 234, 0.3);
  border-left: none;
}
</style>
